import React from 'react';
import VideoSlide from '../body/VideoSlide';

const EzParentIntroVideo = () => {
  return (
    <div className='p-6'>
      <div className='max-w-5xl mx-auto'>
        <VideoSlide vidSrc='/ezparent_intro.mp4' />
      </div>
    </div>
  );
};

export default EzParentIntroVideo;
